import { render } from "./Exceptions.vue?vue&type=template&id=05de65f9&ts=true"
import script from "./Exceptions.vue?vue&type=script&lang=ts"
export * from "./Exceptions.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__